<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <!-- Table Header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div class="p-0 text-start pt-2">
                <a class="p-0 back-button text-primary" style="cursor: pointer" :title="$t('key_shipmentDetailTableHeader_button_back')" @click="$router.go(-1)">
                  <i class="fa fa-arrow-circle-left" style="font-size: 35px;"></i>
                </a>
              </div>
              <div class="ms-3">
                  <h5 class="mb-0">{{ title }}</h5>
                  <p class="mb-0 text-sm">{{ description }}</p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <!-- Interactions with database (filters and reload) -->
                  <ReloadButton :title="$t('key_shipmentListTableHeader_button_reload_shipment')" @change="getShipment"/>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Tabla con los Datos -->
          <div class="scrollable">
            <GenericTableScrollable
              v-if="!!shipmentData"
              ref="genericTable"
              :items="shipmentData.packages"
              :headers="headers"
              :is-loading="isLoading"> <!-- @row-change="paginationRowChange" -->
              <template #row="bulto">
                <td style="width: 10rem" class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{bulto.locator}}</span>
                </td>
                <td class="font-weight-bold">
                  <shipment-package-content v-if="bulto.content" :content="bulto.content"></shipment-package-content>
                </td>
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{$numberFormat.toAmount(bulto.weight)}} {{ 'Kg.' }}</span>
                </td>
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{ bulto.length }} x {{ bulto.height }} x {{ bulto.width }}</span>
                </td>
                <td class="font-weight-bold">
                  <shipment-package-batch-content v-if="bulto.content" :content="bulto.content"></shipment-package-batch-content>
                </td>
                <td class="font-weight-bold">
                  <shipment-package-batch-date-content v-if="bulto.content" :content="bulto.content"></shipment-package-batch-date-content>
                </td>
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{bulto.tracking_number}}</span>
                </td>
                <td class="font-weight-bold text-center">
                  <a
                    class="mx-3"
                    :class="!bulto.tracking_url || bulto.tracking_url === '' ? 'disable-link' : ''"
                    :title="!bulto.tracking_url || bulto.tracking_url === '' ? $t('key_no_tracking_number') : $t('key_tracking_number')"
                    target="_blank" :href="bulto.tracking_url || '#'">
                    <i :class="bulto.tracking_url || bulto.tracking_url !== '' ? 'fa-solid fa-location-dot text-primary' : 'fa-solid fa-location-dot text-danger'"></i>
                  </a>
                </td>
              </template>
            </GenericTableScrollable>
          </div>
          <div class="col-12 row">
            <shipment-footer :shipment-data="shipmentData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import GenericTableScrollable from "../../../picko_components/generic_components/GenericTableScrollable.vue";
  import ReloadButton from "./../../../picko_components/generic_components/ReloadButton.vue";
  import ShipmentPackageContent from "./ShipmentPackageContent.vue";
  import ShipmentPackageBatchContent from "./ShipmentPackageBatchContent.vue";
  import ShipmentPackageBatchDateContent from "./ShipmentPackageBatchDateContent.vue";
  import ShipmentFooter from "./ShipmentFooter.vue";

  export default {
    name: "ShipmentDetails",
    components: {
      ShipmentFooter,
      ShipmentPackageContent,
      GenericTableScrollable,
      ReloadButton,
      ShipmentPackageBatchContent,
      ShipmentPackageBatchDateContent
    },
    data() {
      return {
        isLoading: false
      };
    },
    computed: {
      shipmentData() {
        return this.$store.state.shipment.shipment.data;
      },
      headers() {
        return [
          //{ title: this.$t('key_theader_PurchaseDetail_id'), sort: { sorteable: true, order: '' }, column: 'id' },
          { title: this.$t('key_theader_ShipmentList_locator'), sort: { sorteable: true, order: '' }, column: 'packages.locator' },
          { title: this.$t('key_theader_ShipmentList_eans'), sort: { sorteable: true, order: '' }, column: 'packages.content.ean' },
          { title: this.$t('key_theader_ShipmentList_weight'), sort: { sorteable: true, order: '' }, column: 'packages.weight' },
          { title: this.$t('key_theader_ShipmentList_packaging_size'), sort: { sorteable: false, order: '' } },
          { title: this.$t('key_theader_ShipmentList_batch'), sort: { sorteable: true, order: '' }, column: 'packages.content.batch' },
          { title: this.$t('key_theader_ShipmentList_batch_date'), sort: { sorteable: true, order: '' }, column: 'packages.content.batch_date' },
          { title: this.$t('key_theader_ShipmentList_tracking_number'), sort: { sorteable: true, order: '' }, column: 'tracking_number' },
          { title: this.$t('key_theader_ShipmentList_tracking'), sort: { sorteable: false, order: '' } }
        ];
      },
      title() {
        return this.shipmentData ? this.shipmentData.number + ' - ' + this.$dateUtils.toNoHourLongDate(this.shipmentData.date) : '';
      },
      description() {
        return this.shipmentData ? this.$t('key_PurchaseDetail_Reference') + ': ' + this.shipmentData.reference : '';
      }
    },
    watch: {
      shipmentData() {
        if(this.shipmentData) {
          this.isLoading = false;
        }
      }
    },
    mounted() {
      this.getShipment();
      
    },
    methods: {
      getShipment() {
        if (this.isLoading) return;

        this.isLoading = true;
        this.$store.commit("shipment/getById", this.$route.params.id);
      }
    }
  };

</script>

<style scoped>

  .disable-link {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
    text-decoration: none;
  }

  .image {
    height: 2.2rem !important;
    border-radius: 9%;
  }

  .units ul {
    list-style-type: none;
    text-align: center;
    padding: 0rem;
    margin-bottom: 0rem;
  }

  .scrollable {
    height: 25rem !important;
    overflow: auto;
  }
  
  .columns {
      max-width: 150px;
  }

</style>